import { render, staticRenderFns } from "./AwardCreatorWidget.vue?vue&type=template&id=d17231a0&scoped=true"
import script from "./AwardCreatorWidget.vue?vue&type=script&lang=js"
export * from "./AwardCreatorWidget.vue?vue&type=script&lang=js"
import style0 from "./AwardCreatorWidget.vue?vue&type=style&index=0&id=d17231a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17231a0",
  null
  
)

export default component.exports